import { Http, Request, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { hasContent, CwError, NETWORK_CONNECTION_ERROR, UNKNOWN_RESPONSE_ERROR, CLIENTS_ONLY_MESSAGES, SERVER_RESPONSE_ERROR } from './util/http-response-util';
import { ApiRoot } from './api-root.service';
import { ResponseView } from './util/response-view';
import { LoggerService } from './logger.service';
import { BrowserUtil } from './browser-util.service';
import { HttpCode } from './util/http-code';
import { Router } from '@angular/router';
export var RULE_CREATE = 'RULE_CREATE';
export var RULE_DELETE = 'RULE_DELETE';
export var RULE_UPDATE_NAME = 'RULE_UPDATE_NAME';
export var RULE_UPDATE_ENABLED_STATE = 'RULE_UPDATE_ENABLED_STATE';
export var V_RULE_UPDATE_EXPANDED_STATE = 'V_RULE_UPDATE_EXPANDED_STATE';
export var RULE_UPDATE_FIRE_ON = 'RULE_UPDATE_FIRE_ON';
export var RULE_RULE_ACTION_CREATE = 'RULE_RULE_ACTION_CREATE';
export var RULE_RULE_ACTION_DELETE = 'RULE_RULE_ACTION_DELETE';
export var RULE_RULE_ACTION_UPDATE_TYPE = 'RULE_RULE_ACTION_UPDATE_TYPE';
export var RULE_RULE_ACTION_UPDATE_PARAMETER = 'RULE_RULE_ACTION_UPDATE_PARAMETER';
export var RULE_CONDITION_GROUP_UPDATE_OPERATOR = 'RULE_CONDITION_GROUP_UPDATE_OPERATOR';
export var RULE_CONDITION_GROUP_DELETE = 'RULE_CONDITION_GROUP_DELETE';
export var RULE_CONDITION_GROUP_CREATE = 'RULE_CONDITION_GROUP_CREATE';
export var RULE_CONDITION_CREATE = 'RULE_CONDITION_CREATE';
export var RULE_CONDITION_DELETE = 'RULE_CONDITION_DELETE';
export var RULE_CONDITION_UPDATE_TYPE = 'RULE_CONDITION_UPDATE_TYPE';
export var RULE_CONDITION_UPDATE_PARAMETER = 'RULE_CONDITION_UPDATE_PARAMETER';
export var RULE_CONDITION_UPDATE_OPERATOR = 'RULE_CONDITION_UPDATE_OPERATOR';
var CoreWebService = (function () {
    function CoreWebService(_apiRoot, _http, loggerService, browserUtil, router) {
        this._apiRoot = _apiRoot;
        this._http = _http;
        this.loggerService = loggerService;
        this.browserUtil = browserUtil;
        this.router = router;
        this.httpErrosSubjects = [];
    }
    CoreWebService.prototype.request = function (options) {
        var _this = this;
        var request = this.getRequestOpts(options);
        var source = options.body;
        return this._http
            .request(request)
            .map(function (resp) {
            return hasContent(resp) ? resp.json() : resp;
        })
            .catch(function (response, original) {
            if (response) {
                _this.handleHttpError(response);
                if (response.status === HttpCode.SERVER_ERROR || response.status === HttpCode.FORBIDDEN) {
                    if (response.text() && response.text().indexOf('ECONNREFUSED') >= 0) {
                        throw new CwError(NETWORK_CONNECTION_ERROR, CLIENTS_ONLY_MESSAGES[NETWORK_CONNECTION_ERROR], request, response, source);
                    }
                    else {
                        throw new CwError(SERVER_RESPONSE_ERROR, response.headers.get('error-message'), request, response, source);
                    }
                }
                else if (response.status === HttpCode.NOT_FOUND) {
                    _this.loggerService.error('Could not execute request: 404 path not valid.', options.url);
                    throw new CwError(UNKNOWN_RESPONSE_ERROR, response.headers.get('error-message'), request, response, source);
                }
            }
            return null;
        });
    };
    /**
   * Return a response adapted to the follow json format:
   *
   * <code>
   * {
   *   "errors":[],
   *   "entity":{},
   *   "messages":[],
   *   "i18nMessagesMap":{}
   * }
   * </code>
   *
   * @param options
   * @returns {DotCMSHttpResponse}
   */
    CoreWebService.prototype.requestView = function (options) {
        var _this = this;
        var request = this.getRequestOpts(options);
        return this._http.request(request)
            .map(function (resp) {
            if (resp.json().errors && resp.json().errors.length > 0) {
                return _this.handleRequestViewErrors(resp);
            }
            else {
                return new ResponseView(resp);
            }
        })
            .catch(this.handleRequestViewErrors.bind(this));
    };
    CoreWebService.prototype.handleRequestViewErrors = function (resp) {
        if (resp.status === 401) {
            this.router.navigate(['/public/login']);
        }
        return Observable.throw(new ResponseView(resp));
    };
    CoreWebService.prototype.subscribeTo = function (httpErrorCode) {
        if (!this.httpErrosSubjects[httpErrorCode]) {
            this.httpErrosSubjects[httpErrorCode] = new Subject();
        }
        return this.httpErrosSubjects[httpErrorCode].asObservable();
    };
    CoreWebService.prototype.getRequestOpts = function (options) {
        var headers = this._apiRoot.getDefaultRequestHeaders();
        var tempHeaders = options.headers
            ? options.headers
            : { 'Content-Type': 'application/json' };
        Object.keys(tempHeaders).forEach(function (key) {
            headers.set(key, tempHeaders[key]);
        });
        // https://github.com/angular/angular/issues/10612#issuecomment-238712920
        options.body =
            options.body && typeof options.body !== 'string'
                ? JSON.stringify(options.body)
                : options.body ? options.body : '';
        options.headers = headers;
        if (options.url.indexOf('://') === -1) {
            options.url = this._apiRoot.baseUrl + "api/" + options.url;
        }
        if (this.browserUtil.isIE11()) {
            options = options || {};
            options.search = options.search || new URLSearchParams();
            var currentTime = new Date().getTime();
            options.search.set('timestamp', String(currentTime));
        }
        return new Request(options);
    };
    CoreWebService.prototype.handleHttpError = function (response) {
        if (!this.httpErrosSubjects[response.status]) {
            this.httpErrosSubjects[response.status] = new Subject();
        }
        this.httpErrosSubjects[response.status].next(response);
    };
    return CoreWebService;
}());
export { CoreWebService };
CoreWebService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
CoreWebService.ctorParameters = function () { return [
    { type: ApiRoot, },
    { type: Http, },
    { type: LoggerService, },
    { type: BrowserUtil, },
    { type: Router, },
]; };
//# sourceMappingURL=core-web.service.js.map